import { Component, OnInit, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly swUpdate = inject(SwUpdate);
  private readonly snackBar = inject(MatSnackBar);

  ngOnInit(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(
        filter(
          (event): event is VersionReadyEvent =>
            event.type === 'VERSION_READY',
        ),
      )
      .subscribe(() => {
        const ref = this.snackBar.open(
          'Hay una nueva versión disponible',
          'Actualizar',
          { duration: 0 },
        );
        ref.onAction().subscribe(() => {
          this.swUpdate
            .activateUpdate()
            .then(() => document.location.reload());
        });
      });
  }
}
